import React, { useEffect } from 'react';
import Row from 'components/Row';
import Text from 'components/Text';

import { CoachingReservation } from 'coaching/containers/GetAvailableReservationsContainer';
import CoachingHeading from 'coaching/components/CoachingHeading';
import TutoringSelfServeViewBilingSessionDetails from 'coaching/components/TutoringSelfServeView/TutoringSelfServeViewBilling/TutoringSelfServeViewBillingSessionDetails';
import Button from 'components/ButtonDeprecated';
import Display from 'components/Display';
// @ts-ignore
import userAgent from 'lib/currentUserAgent';
import { pushCustomEvent } from 'lib/googleTagManager';
import LinkConstants from 'constants/LinkConstants';
import CurrentUser from 'auth/CurrentUser';
import { InjectedRouter } from 'react-router';
import CoachingConstants from 'coaching/CoachingConstants';
import {
  getReservationOrThrow,
  getSelectedSubjectOrThrow,
  getUserTimezone,
  resolveChildName,
} from 'lib/TutoringStateMachine/TutoringDataHelpers';
import { clearSignupStorage } from 'lib/TutoringStateMachine/SignUpStorage';
import EventTracking from 'lib/EventTracking';

const eventKeyPrefix = 'coaching.self_schedule_purchase.success';

export type Props = {
  router: InjectedRouter;
};

export type ViewSummaryInputData = {
  selectedSubject: string;
  selectedUserTimezone: string;
  selectedReservation: CoachingReservation;
  childName?: string;
};

export function retrieveDataForTutoringSelfServeViewSummary(): ViewSummaryInputData {
  return {
    selectedSubject: getSelectedSubjectOrThrow(),
    selectedReservation: getReservationOrThrow(),
    selectedUserTimezone: getUserTimezone(),
    childName: resolveChildName(),
  };
}

export default function TutoringSelfServeViewSummary(props: Props) {
  useEffect(() => {
    EventTracking.trackKey(`${eventKeyPrefix}.view`);
    pushCustomEvent('coaching_success_screen');
  }, []);

  const {
    selectedSubject,
    selectedReservation,
    selectedUserTimezone,
    childName,
  } = retrieveDataForTutoringSelfServeViewSummary();

  function onContinuePressedInDesktop() {
    if (CurrentUser.isSignedIn()) {
      props.router.replace(CoachingConstants.COACHING_HOME_ROUTE);
    } else {
      props.router.replace(CoachingConstants.GENERALIZED_SIGN_IN_ROUTE);
    }
  }
  const addAccountButtonProps = {
    color: 'koolaid',
    level: 'primary',
    size: 'medium',
    'data-test': 'signup-summary-continue-button',
    onClick: () => {
      clearSignupStorage();
      if (userAgent.isDesktop()) {
        onContinuePressedInDesktop();
      }
    },
    href: getContinueButtonTarget(),
  } as const;
  const buttonText = getContinueButtonText();

  return (
    <>
      <Row size="xsmall">
        <CoachingHeading>You are all set!</CoachingHeading>
      </Row>
      <Row size="xlarge">
        <TutoringSelfServeViewBilingSessionDetails
          reservation={selectedReservation}
          userTimezone={selectedUserTimezone}
          studentName={childName}
          selectedSubject={selectedSubject}
        />
      </Row>
      <Row size="medium">
        <Row size="xxsmall">
          <Text size="medium">
            Log in to Remind to message your tutor, see your schedule, and more!
          </Text>
        </Row>

        <Display show="480">
          <Button {...addAccountButtonProps} full eventKey={`${eventKeyPrefix}.skip.click`}>
            {buttonText}
          </Button>
        </Display>
        <Display hide="480">
          <Button {...addAccountButtonProps}>{buttonText}</Button>
        </Display>
      </Row>
    </>
  );
}

function getContinueButtonText() {
  if (userAgent.isDesktop() && CurrentUser.isSignedIn()) {
    return 'View your dashboard';
  } else if (userAgent.isDesktop() && !CurrentUser.isSignedIn()) {
    return 'Log in to continue';
  } else {
    return 'Download the app';
  }
}

function getContinueButtonTarget() {
  if (userAgent.isDesktop() && CurrentUser.isSignedIn()) {
    return CoachingConstants.COACHING_HOME_ROUTE;
  } else if (userAgent.isDesktop() && !CurrentUser.isSignedIn()) {
    return CoachingConstants.GENERALIZED_SIGN_IN_ROUTE;
  } else {
    return LinkConstants.APP_DOWNLOAD;
  }
}
